import script from "./UploadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImage.vue?vue&type=script&setup=true&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=5d933f04&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d933f04"]])

export default __exports__